import { Search } from "lucide-react";

import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import useSocketMessage from "@/store/socket-message";

const LinkTable = () => {
    const { messages, connectionStatus } = useSocketMessage();

    if (connectionStatus === "Connected" && messages.length > 0) {
        return (
            <Card className="mt-4 p-4 text-gray-700 shadow-none">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <Search className="animate-bounce" />
                        <div>
                            <h4 className="text-lg font-semibold">Data Fetching Is Progressing</h4>
                            <p>It usually takes 1 to 5 minutes. {messages.length || 0} pages fetched so far.</p>
                        </div>
                    </div>
                </div>
                <Separator className="my-4" />
                <div className="mt-4 max-h-96 overflow-y-auto">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>Web Page Link</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {messages.map((msg, index) => (
                                <TableRow key={index}>
                                    <TableCell className="font-semibold text-green-600">{msg}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </Card>
        );
    }

    return (
        <Card className="mt-4 p-4 text-gray-700 shadow-none">
            <div className="flex flex-col items-center justify-between">
                <img src={"/assets/images/illustrations/empty.svg"} height={400} width={400} alt="no process" />
                <h3 className="my-4 text-lg font-semibold text-slate-700">No Active Trainings</h3>
            </div>
        </Card>
    );
};

export default LinkTable;
